import { render } from "./MemoryChart.vue?vue&type=template&id=0a234ddc&scoped=true"
import script from "./MemoryChart.vue?vue&type=script&lang=js"
export * from "./MemoryChart.vue?vue&type=script&lang=js"

import "./MemoryChart.vue?vue&type=style&index=0&id=0a234ddc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a234ddc"]])

export default __exports__